import script from "./ApplicationPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./ApplicationPage.vue?vue&type=script&setup=true&lang=ts"

import "./ApplicationPage.vue?vue&type=style&index=0&id=3199353d&lang=scss"

const __exports__ = script;

export default __exports__